export default {
  info: {
    webVersion: 'Version web',
    appVersion: 'Version native',
    platform: 'Plateforme',
    userID: 'ID utilisateur',
    familyID: 'ID famille',
  },
};
